const NZ_TIMEZONE = "Pacific/Auckland";
const NZ_LOCALE = "en-NZ";

export function formatNZDate(dateStr) {
  if (!dateStr) return "N/A";
  return new Date(dateStr).toLocaleDateString(NZ_LOCALE, {
    timeZone: NZ_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  });
}

export function formatNZDateTime(dateStr) {
  if (!dateStr) return "N/A";
  return new Date(dateStr).toLocaleDateString(NZ_LOCALE, {
    timeZone: NZ_TIMEZONE,
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
  }) + " " + new Date(dateStr).toLocaleTimeString(NZ_LOCALE, {
    timeZone: NZ_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit"
  });
}

export function formatNZDateLong(dateStr) {
  if (!dateStr) return "N/A";
  return new Date(dateStr).toLocaleDateString(NZ_LOCALE, {
    timeZone: NZ_TIMEZONE,
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function getNZNow() {
  return new Date(new Date().toLocaleString("en-US", { timeZone: NZ_TIMEZONE }));
}
